import { useState } from "react";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../constants";
import toast from "react-hot-toast";
import { createStockAdjustmentNote, deleteStockAdjustmentNote, getSANMaterials, getStockAdjustmentNote, getStockAdjustmentNoteById, updateStockAdjustmentNote } from "../../../Services/StockAdjustmentNoteService";

export const useSAN = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
    warehouse: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchAllSANs = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getStockAdjustmentNote({
        ...filters,
        ...params,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      });
      if (response.status === 200) {
        setTotalPages(
          Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
        );
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.SAN_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.SAN_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchSANMaterial = async (SANId, params) => {
    try {
      const response = await getSANMaterials(SANId, params);
      if (response.status === 200) {
        return response.data.results;
      } else {
        toast.error(TOAST_MESSAGES.FAILED_FETCH_SAN);
        return null;
      }
    } catch (error) {
      toast.error(TOAST_MESSAGES.FAILED_FETCH_SAN);
      return null;
    }
  };

  const fetchSANById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getStockAdjustmentNoteById(id);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.SAN_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.SAN_FETCH_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const newSAN = async (payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await createStockAdjustmentNote(payload);
      if (response.status === 201) {
        data = response.data;
        const msg = TOAST_MESSAGES.SAN_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.SAN_CREATE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.SAN_CREATE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const updateSANDetails = async (SANId, payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await updateStockAdjustmentNote(SANId, payload);
      if (response.status === 200) {
        data = response.data;
        const msg = TOAST_MESSAGES.UPDATE_SAN_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.UPDATE_SAN_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_SAN_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteSAN = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await deleteStockAdjustmentNote(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.SAN_DELETE);
        data = true;
      } else {
        const msg =
          extractErrorMessage(response) ||
          TOAST_MESSAGES.FAILED_TO_DELETE_SAN;
        toast.error(msg);
        data = false;
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_TO_DELETE_SAN
      );
      data = false;
    } finally {
      setLoading(false);
      return data;
    }
  };


  const fetchSANMaterials = async (instanceId) => {
    setLoading(true);
    let data = null;
    try {
      const res = await getSANMaterials(instanceId);
      data = res?.data || [];

    } catch (err) {
      toast.error(extractErrorMessage(err) || TOAST_MESSAGES.SAN_DN_FETCH_FAILED);
    } finally {
      setLoading(false);
      return data;
    }
  };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchAllSANs,
    deleteSAN,
    newSAN,
    fetchSANById,
    updateSANDetails,
    fetchSANMaterial,
    fetchSANMaterials
  };
};
